import { render } from "./AddEditEvent.vue?vue&type=template&id=5e336b33&ts=true"
import script from "./AddEditEvent.vue?vue&type=script&lang=ts"
export * from "./AddEditEvent.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\wamp64\\www\\hayllissac\\sistema\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__